import React from "react";
import { Plug2, Undo2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

const InitialPage: React.FC = () => {
  const navigate = useNavigate();

  const bounceHorizontal: React.CSSProperties = {
    animation: "bounce-horizontal 6s ease-in-out infinite alternate",
    willChange: "transform",
  };

  return (
    <div className="h-[95%] relative">
      <div className="flex justify-between items-center h-full">
        <div className="relative w-full h-full rounded-2xl shadow p-10 animate-fade-in overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0 opacity-5 pointer-events-none">
            <div style={bounceHorizontal}>
              <Plug2
                size={600}
                strokeWidth={2.5}
                className="text-primary rotate-90"
              />
            </div>
          </div>

          <div className="relative z-10 flex flex-col items-start max-w-6xl w-full">
            <div className="flex items-center gap-2 mb-4 animate-fade-in">
              <span className="w-2 h-2 rounded-full bg-primaryGreen animate-pulse" />
              <span className="text-[12px] font-mono uppercase tracking-[0.14em] text-muted-foreground">
                Welcome to
              </span>
            </div>

            <div className="flex items-center gap-2.5 mb-2 animate-slide-up">
              <span className="text-[35px] font-medium tracking-tight text-foreground/70 ml-2">
                <span className="text-primary">Link</span>
                <span className="bg-gradient-to-b from-muted to-foreground bg-clip-text text-transparent">
                  Shadow
                </span>
              </span>
            </div>

            <h1 className="text-[62px] font-bold tracking-[-0.04em] leading-none text-foreground mb-6 animate-slide-up [animation-delay:100ms]">
              Mesh
              <span className="text-muted-foreground font-semibold">
                ConnectX
              </span>
            </h1>

            <div className="w-8 h-px bg-border mb-5 animate-slide-up [animation-delay:200ms]" />
            <div className="flex items-center gap-3 animate-slide-up [animation-delay:300ms]">
              <div className="flex gap-1.5">
                {[0, 150, 300].map((delay) => (
                  <span
                    key={delay}
                    className="w-2 h-2 rounded-full bg-primary animate-pulse"
                    style={{ animationDelay: `${delay}ms` }}
                  />
                ))}
              </div>
              <span className="text-[11px] font-mono uppercase tracking-[0.06em] text-muted-foreground">
                Initializing seamless integration
              </span>
            </div>
          </div>
        </div>

        {/* MESH'S LOGO WILL BE ADDED LATER */}
        {/* <img
        src="/static/ls/images/cmx-wheel/shield/CMX.png"
        className="w-96 opacity-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
      /> */}

        <div
          className="flex w-fit items-center cursor-pointer h-8 text-sm rounded-lg border border-muted hover:border-primary p-5 hover:text-primary transition-colors absolute -bottom-20 -left-2"
          onClick={() => navigate("/ai-engine")}
        >
          <Undo2 size={16} className="mr-1" />
          Back to AI Engine
        </div>
      </div>

      <style>
        {`@keyframes bounce-horizontal {
          0% { transform: translateX(-28px); }
          100% { transform: translateX(28px); }
        }`}
      </style>
    </div>
  );
};

export default InitialPage;
